import React from 'react'

const FooterComp = () => {
  return (
      <div className="row align-items-end">
        <div className="col" style={{background: "#100652", height: "130px"}}>
            One of three columns
        </div>
    </div>
  )
}

export default FooterComp